module.exports = __webpack_public_path__ + "assets/Parallelogram3VDetailed.e8ea283a4917a74c296bf4876eb5ce27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Parallelogram3VDetailed.png
// module id = 545
// module chunks = 0